// extracted by mini-css-extract-plugin
module.exports = {"downshiftWrapper":"searchautocomplete_downshiftWrapper__edkGZ"};